module.exports = __webpack_public_path__ + "img/pdf.230c5da9.png";